import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ServerDiscovery from '../services/ServerDiscovery';
import { consumeAuthNext, exchangeGoogleCode } from '../utils/auth';
import { trackEvent } from '../utils/analytics';

function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const denied = searchParams.get('error');
    const code = searchParams.get('code');
    if (denied) {
      setError('Sign-in was cancelled.');
      return;
    }
    if (!code) {
      setError('Missing Google code.');
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const base = await ServerDiscovery.discoverHttpBase();
        const data = await exchangeGoogleCode(base, code);
        if (cancelled) return;
        trackEvent('google_sign_in');
        if (data.stats) {
          try { localStorage.setItem('langle.stats', JSON.stringify(data.stats)); } catch { /* ignore */ }
        }
        navigate(consumeAuthNext(), { replace: true });
      } catch (e) {
        if (!cancelled) setError(e.message || 'Google sign-in failed');
      }
    })();
    return () => { cancelled = true; };
  }, [searchParams, navigate]);

  return (
    <div className="lng-page">
      <header className="lng-topbar">
        <Link to="/" className="lng-back" aria-label="Back to LangShazam">←</Link>
        <h1 className="lng-brand">Langle</h1>
        <div className="lng-topbar-actions" />
      </header>
      {error ? (
        <div className="lng-error-card">
          <p>{error}</p>
          <p className="lng-error-hint"><Link to="/langle">Back to today's puzzle</Link></p>
        </div>
      ) : (
        <p className="lng-loading">Signing you in…</p>
      )}
    </div>
  );
}

export default AuthCallback;
